import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

class ImportAPI extends BaseAPI {}

function getImportTemplateByType (params) {
  const errorType = params?.ErrorType != null ? `?isErrorFile=${params?.ErrorType}` : ''
  return getApiUrl(apis.ExportAPI) + `/v1/import/download-template/${params.Type}${errorType}`
}

export { getImportTemplateByType }
export default new ImportAPI('v1/import', 'Import', getApiUrl(apis.ExportAPI))
